
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 576 512","fill":"currentColor","stroke":"currentColor"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M573.2 415.9l-125.7-352c-6.822-19.1-24.92-31.86-45.2-31.86H173.8c-20.29 0-38.38 12.75-45.2 31.86L2.9 415.9C-8.326 447.1 14.85 480 48.04 480h479.9c33.26 0 56.36-32.9 45.26-64.1zm-19.1 34.5c-6.1 8.7-15.6 13.6-27 13.6H296v-72c0-4.406-3.594-8-8-8s-8 3.594-8 8v72H48.04c-10.55 0-20.08-4.945-26.16-13.57s-7.527-19.26-3.979-29.2l125.7-352C148.2 56.54 160.3 48 173.8 48H280v72c0 4.4 3.6 8 8 8s8-3.594 8-8V48h106.2c13.49 0 25.6 8.535 30.13 21.24l125.7 352c3.57 9.96 2.17 20.56-3.93 29.16zM288 192c-4.4 0-8 3.6-8 8v112c0 4.4 3.6 8 8 8s8-3.594 8-8V200c0-4.4-3.6-8-8-8z"}})])
          )
        }
      }
    